import styled from "styled-components";
import Background from "../../images/background.png";
import { deviceDF } from "../breakPoints";
export const Container = styled.div`
  padding: 3rem 2rem;
  height: ${props => props.stepTwo ? 'auto' : '100vh'};
  display: flex;
  align-items: center;
  flex-direction: column;
  background-image: url(${Background});
  background-repeat: no-repeat;
  background-position: center;
  /* background-size: 500px; */
`;

export const FormStyled = styled.form`
  width: 450px;
  display: flex;
  flex-direction: column;
  margin: 2rem 0;
  @media ${deviceDF.laptop} {
    width: 400px;
  }
  @media ${deviceDF.mobileL} {
    width: 300px;
  }
  @media ${deviceDF.mobileM} {
    width: 250px;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
`;

export const BarStyled = styled.div`
  border: none;
  box-sizing: border-box;
  width: 120px;
  background: #e30613;
  height: 14px;
  border-radius: 7px;
  margin-bottom: 1.6rem;
  align-self: center;
`;

export const CaptchaWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 1.2rem;
`;

export const FilesTitle = styled.h3`
  display: block;
  text-align: center;
  color: #126bdc;
  margin-top: 2rem;
`;

export const ImagesContainer = styled.div`
  width: 300px;
  margin: 3rem 0;
  display: flex;
  justify-content: space-between;
`;
export const ImageText = styled.a`
  text-decoration: underline;
  color: #126bdc;
  display: block;
  text-align: center;
  font-size: 18px;
  margin-top: 0.5rem;
`;

export const ImgGlobalBlur = styled.img`
  @media ${deviceDF.mobileL} {
    width: 300px;
    height: 900px;
  }
  @media ${deviceDF.mobileM} {
    width: 300px;
    height: 900px;
  }   
  
`